// angular
// 	.module("HeroPRO")
// 	.directive('hpNotificationFooter', notificationFooterDirective);

export default function notificationFooterDirective() {
    return {
        restrict: 'E',
        controller: 'NotificationFooterController',
        controllerAs: 'notificationFooter',
        bindToController: true,
        scope: {
            notificationMessage: '=?',
        },
        templateUrl: 'app/notificationCenter/footer/notificationFooter.html',
        link,
    };

    function link() {

    }
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/footer/notificationFooterDirective.js